export const API_URL = process.env.REACT_APP_API_URL;
export const RZR_PAY_KEY_ID = process.env.REACT_APP_RZR_PAY_KEY_ID;
export const REACT_APP_GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const REACT_APP_JKEY = process.env.REACT_APP_JKEY;
export const REACT_APP_HKEY = process.env.REACT_APP_HKEY;
export const REACT_APP_GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;